import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useLocation, useSearch } from 'wouter';
import { getStudents } from '../../services/api';

interface Student {
  id: string;
  name: string;
}

interface StudentSelectorProps {
  selectedStudentId?: string;
}

const StudentSelector: React.FC<StudentSelectorProps> = ({ selectedStudentId }) => {
  const [students, setStudents] = useState<Student[]>([]);
  const [, setLocation] = useLocation();
  const searchParams = useSearch();

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      let data = await getStudents();
      data = data.sort((a, b) => a.name.localeCompare(b.name));
      setStudents(data);
    } catch (error) {
      console.error('Error fetching students:', error);
    }
  };

  const handleStudentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const studentId = e.target.value;
    if (studentId) {
      // Preserve existing query parameters
      const queryString = searchParams ? `?${searchParams}` : '';
      setLocation(`/attendance/student/${studentId}${queryString}`, { replace: true });
    }
  };

  return (
    <Form.Group className="mb-3">
      <Form.Label>Select Student</Form.Label>
      <Form.Select
        value={selectedStudentId || ''}
        onChange={handleStudentChange}
      >
        <option value="">-- Select a student --</option>
        {students.map((student) => (
          <option key={student.id} value={student.id}>
            {student.name}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};

export default StudentSelector;
